import React from "react";
import { Dropdown } from "../Dropdown/Dropdown.tsx";
import styles from "./MonthPicker.module.css";

const monthItems = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
].map((name, index) => {
  return {
    label: name,
    value: (index + 1).toString().padStart(2, "0"),
  };
});

const yearItems = Array.from(
  { length: new Date().getFullYear() - 1975 + 1 },
  (_, i) => (1975 + i).toString(),
)
  .map((year) => {
    return {
      label: year,
      value: year,
    };
  })
  .reverse();

type Value = {
  month?: string;
  year?: string;
};

/**
 * MonthPicker component allows the user to select a month and year.
 *
 * This works exclusively as a controlled component, meaning that the value and onSelect props are required.
 * It also means that the component does not manage its own state.
 */
export const MonthPicker: React.FC<{
  value: Value;
  onSelect: (value: Value) => void;
}> = ({ value, onSelect }) => {
  return (
    <div className={styles.MonthPicker}>
      <Dropdown
        items={monthItems}
        placeholder={"Month"}
        selected={value.month ? [value.month] : []}
        onSelect={([selectedMonth]) => {
          onSelect({ ...value, month: selectedMonth });
        }}
        minWidth={"90px"}
      />
      <Dropdown
        items={yearItems}
        placeholder={"Year"}
        selected={value.year ? [value.year] : []}
        onSelect={([selectedYear]) => {
          onSelect({ ...value, year: selectedYear });
        }}
        minWidth={"90px"}
      />
      <CalendarIcon />
    </div>
  );
};

const CalendarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M14.6667 4.99414V6.29414H9.33333V4.99414H8V6.29414H7.33333C6.59333 6.29414 6.00667 6.87914 6.00667 7.59414L6 16.6941C6 17.4091 6.59333 17.9941 7.33333 17.9941H16.6667C17.4 17.9941 18 17.4091 18 16.6941V7.59414C18 6.87914 17.4 6.29414 16.6667 6.29414H16V4.99414H14.6667ZM16.6667 16.6941H7.33333V9.54414H16.6667V16.6941Z"
        fill="currentColor"
        fillOpacity="0.93"
      />
    </svg>
  );
};
